import Stack from "@mui/material/Stack";
import DataContainer from "../../../Utilities/DataContainer";
import RenderSelectField from "../../../Utilities/Forms/RenderSelectField";
import RenderTextField from "../../../Utilities/Forms/RenderTextField";
import { useContext } from "react";
import { SessionContext } from "../../../Contexts/SessionContext";

const dropdown = [
    { id: '1', label: 'No' },
    { id: '2', label: 'Yes' },
];

interface IProps {
    hasParkingDetails?: boolean | null;
    isReadOnly: boolean;
}
export default function Parking({ isReadOnly, hasParkingDetails }: IProps) {
    const { sessionState } = useContext(SessionContext);
    return (
        <>
            {!hasParkingDetails && sessionState.siteListMain !== '13' &&
                <DataContainer title="Parking">
                    <Stack spacing={1}>
                        <RenderTextField label="Total" name="parkingDetails.total" readOnly={isReadOnly} />
                        <RenderTextField label="Spaces Per 100m2 GFA" name="parkingDetails.spacesPerGFA" readOnly={isReadOnly} />
                        <RenderTextField label="Spaces Per 100m2 RFA" name="parkingDetails.spacesPerRFA" readOnly={isReadOnly} />
                        <RenderTextField label="Visitor/Customer" name="parkingDetails.visitorCustomer" readOnly={isReadOnly} />
                        <RenderTextField label="Employee" name="parkingDetails.employee" readOnly={isReadOnly} />
                        <RenderTextField label="Disabled" name="parkingDetails.disabled" readOnly={isReadOnly} />
                        <RenderTextField label="OGV Loading Bays" name="parkingDetails.oGVLoadingBays" readOnly={isReadOnly} />
                        <RenderTextField label="OGV Parking Bays" name="parkingDetails.oGVParkingBays" readOnly={isReadOnly} />
                        <RenderTextField label="Parent And Todler" name="parkingDetails.parentAndTodler" readOnly={isReadOnly} />
                        <RenderTextField label="Motorcycle Spaces" name="parkingDetails.motorcycleSpaces" readOnly={isReadOnly} />
                        <RenderTextField label="Cycle Racks" name="parkingDetails.cycleRacks" readOnly={isReadOnly} />
                        <RenderTextField label="Parking Charges" name="parkingDetails.parkingCharges" readOnly={isReadOnly} />
                        <RenderTextField label="Surface Parking" name="parkingDetails.surfaceParking" readOnly={isReadOnly} />
                        <RenderSelectField label="Off Site Parking Available" name="parkingDetails.offSiteParkingAvailable" readOnly={isReadOnly} options={dropdown} />
                        <RenderSelectField label="Off Site Parking Included In Count" name="parkingDetails.offSiteParkingIncludedInCount" readOnly={isReadOnly} options={dropdown} />
                    </Stack>
                </DataContainer>
            }
        </>

    );
}